import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/images/finallogo.png"
import payment from "../assets/images/payment.png"
import { get_settings_section } from '../api/Global';
import { get_pages_section } from '../api/Global';


const Footer = () => {
  const [get_settings, set_get_settings] = useState({});
   const [pages, setPages] = useState([]);

  useEffect(() => {
    const handle_get_settings = async () => {
      try {
        const response = await get_settings_section();
        set_get_settings(response?.data?.data?.settings);

        const pageRes = await get_pages_section();
        if (pageRes.status === 200) {
          setPages(pageRes.data.data);
        }
      } catch (error) {
        console.log('error', error);
      }
    };
    handle_get_settings();
  }, []);

  const processedSupportLinks = [
    { name: 'Contact Us', href: '/contact-us' },
    { name: 'Privacy and Policy', href: '/privacy-policy' },
    ...pages.map((item) => {
      if (item.title === 'Passport Account Agreement') {
        return { name: item.title, href: '/agreement', isPdf: true };
      } else if (item.title === 'Terms Of Service') {
        return { name: item.title, href: '/terms-of-service' };
      } else {
        return { name: item.title, href: `/page/${item.id}` };
      }
    }),
  ];
  return (
    <footer className="relative overflow-hidden border-t border-cyan-500/25 bg-[#17222e] lg:pt-12">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(22,151,239,0.10),transparent_40%),radial-gradient(circle_at_80%_100%,rgba(41,195,106,0.08),transparent_35%)]" />
      <div className="relative mx-auto w-full max-w-screen-xl px-4 py-10 lg:py-12">
        <div className="grid items-start gap-10 md:grid-cols-4 md:gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-flex items-center">
              <img
                alt="Orbitpay"
                src={logo}
                className="h-14.5 w-auto"
              />
            </Link>
            <div className="mt-5">
              <p className="text-white font-semibold text-lg leading-7">{get_settings?.description}</p>
              <p className="mt-4 text-stone-300">{get_settings?.email}</p>
              <p className="mt-1 text-stone-300">Toll-Free: 1 (800) 941-0125</p>
            </div>
            <Link
              to="/contact-us"
              className="theme-btn-primary inline-flex mt-5 px-5 py-2.5 text-sm"
            >
              Request Callback
            </Link>
          </div>
          <div className="md:col-span-1">
            <h2 className="mb-4 text-xs font-semibold tracking-[0.14em] text-cyan-300 uppercase">
              Services
            </h2>
            <ul className="p-0 m-0">
              {[
                { name: "AC Repair & Servicing", href: "/hosting" },
                { name: "Electrical Utility Work", href: "/hosting" },
                { name: "Plumbing Utility Service", href: "/hosting" },
                { name: "Home Utility Maintenance", href: "/hosting" }
              ].map((link, i) => (
                <li key={i} className="mb-3">
                  <Link
                    to={link.href}
                    className="text-stone-300 font-medium no-underline hover:text-cyan-300 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-1">
            <h2 className="mb-4 text-xs font-semibold tracking-[0.14em] text-cyan-300 uppercase">
              Support
            </h2>
            <ul className="p-0 m-0">
              {processedSupportLinks.map((link, i) => (
                <li key={i} className="mb-3">
                  {link.isPdf ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-stone-300 font-medium no-underline hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-stone-300 font-medium no-underline hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-1">
            <h2 className="mb-4 text-xs font-semibold tracking-[0.14em] text-cyan-300 uppercase">
              Company
            </h2>
            <ul className="p-0 m-0">
              {[
                { name: "About Us", href: "/about-us" },
                { name: "Contact Us", href: "/contact-us" },
                { name: "Terms Of Service", href: "/terms-of-service" },
                { name: "Privacy and Policy", href: "/privacy-policy" }
              ].map((link, i) => (
                <li key={i} className="mb-3">
                  <Link
                    to={link.href}
                    className="text-stone-300 font-medium no-underline hover:text-cyan-300 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <hr className="my-8 border-cyan-800/30 sm:mx-auto lg:my-10" />
        <div className="flex flex-col-reverse gap-4 px-1 py-2 sm:flex-row sm:items-center sm:justify-between">
         <span className="text-sm text-stone-400 sm:text-left">
            © Orbitpay is proudly U.S. Based Company | Address: 3216 Mason Dr, Plano, Texas 75025, 2025{' '}
            <Link to="/" className="hover:underline text-cyan-300 font-semibold">
              Orbitpay
            </Link>. All Rights Reserved. <br />
            
          </span>
          <div className="rounded-lg border border-white/10 bg-white/5 px-3 py-2 sm:justify-center sm:mt-0">
            <img src={payment} alt="Payment Methods" className="h-7 w-auto opacity-95" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
